<div class="inner-mat-dialog flex content-stretch items-stretch flex-col">
    <div><h1 mat-dialog-title>System Alerts</h1></div>
    <div class="flex-1 overflow-auto min-h-0">
        <table mat-table [dataSource]="systems" matSort>
            <!-- Create ng-container for serial number -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef>Serial Number</th>
                <td mat-cell *matCellDef="let element">{{element.alert.asset.machineNo}}</td>
            </ng-container>
            
            <!-- Create ng-container for alert type -->
            <ng-container matColumnDef="alert">
                <th mat-header-cell *matHeaderCellDef>Alert</th>
                <td mat-cell *matCellDef="let element">
                    <span matTooltip="{{getAlertTooltip(element.alert)}}"
                    matTooltipClass="multline-tooltip">{{element.alert.systemAlertType.name}}</span>
                </td>
            </ng-container>
            
            <!-- Create table for most recent ack type -->
            <ng-container matColumnDef="ack">
                <th mat-header-cell *matHeaderCellDef>Acknowledgement</th>
                <td mat-cell *matCellDef="let element">
                    <span matTooltip="{{getAckTooltip(element.latestAck)}}"
                    matTooltipClass="multline-tooltip">{{element.latestAck.systemAlertAckType.name}}</span>
                </td>
            </ng-container>
            
            <!-- Create button to submit an ack when allowed -->
            <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef>Set Acknowledgement</th>
                <td mat-cell *matCellDef="let element">
                    @if (!isResolved(element.latestAck)) {
                        <button mat-button class="btn-default btn-edit" (click)="onEdit(element.alert)">Edit</button>
                    }
                </td>
            </ng-container>
            
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
    <mat-dialog-actions class="flex justify-end content-end items-end w-full flex-row">
        <button mat-button class="btn-primary btn-done" (click)="onDoneClicked()">Done</button>
    </mat-dialog-actions>
</div>